import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, renderList as _renderList, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b258dcdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ml-30" }
const _hoisted_2 = { class: "min-h-24" }
const _hoisted_3 = { class: "font-bold mr-8" }
const _hoisted_4 = { class: "font-bold mr-8" }
const _hoisted_5 = {
  key: 0,
  class: "mb-x2 bg-wild-sand py-x2 px-25 mt-15 text-14 min-h-95"
}
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "mr-5" }
const _hoisted_8 = { class: "flex my-x4" }
const _hoisted_9 = { class: "mb-x2" }
const _hoisted_10 = { class: "block font-bold" }
const _hoisted_11 = {
  key: 0,
  class: "block"
}
const _hoisted_12 = { class: "block" }
const _hoisted_13 = { class: "block" }
const _hoisted_14 = { class: "block" }
const _hoisted_15 = { class: "block" }
const _hoisted_16 = { class: "mt-x2" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "ml-auto max-w-half" }
const _hoisted_19 = { class: "block font-bold" }
const _hoisted_20 = {
  key: 0,
  class: "c-select c-select--highlighted border-silver w-full min-w-250 mt-7 pr-20"
}
const _hoisted_21 = {
  key: "choose",
  value: ""
}
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "mb-x4" }
const _hoisted_24 = { class: "block font-bold pb-1" }
const _hoisted_25 = { class: "c-input__container" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = { key: 2 }
const _hoisted_28 = {
  key: "doorStepDeliveryOptionsLabel",
  class: "block font-bold mb-8"
}

import InputCheckbox from '@/shared/form/InputCheckbox.vue';
import CheckoutChangeAddress from './CheckoutChangeAddress.vue';
import useBooleanToggle from '@/shared/useBooleanToggle';
import {
    BasketAddress,
    BasketBuyer,
    CustomerDeliveryCheckOutDeliverable,
    DeliveryTimeSlotModel, DeliveryType,
    DeliveryOptionModel, LabelWithNamedArguments,
} from '@/storecontext/shared/api/server-apis';
import { computed, ComputedRef, onMounted, onUnmounted, ref, watch } from 'vue';
import { useCheckout } from '@/storecontext/checkout/useCheckout';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';
import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import CheckoutSkeletonLine from '@/storecontext/shared/checkout/ui/CheckoutSkeletonLine.vue';

interface DeliveryOptionWithSelectedValueModel extends DeliveryOptionModel {
    selected: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutDeliveryOption',
  props: {
    deliverable: null
  },
  setup(__props: any) {

const props = __props as {
    deliverable: CustomerDeliveryCheckOutDeliverable;
}



const labels = useBlockLabels();
const { invoiceAddress, getDeliveryTimesForCustomerDelivery, setDeliveryTime, setCommentForHomeDelivery, getDeliveryOptions, addDeliveryOption, removeDeliveryOption } = useCheckout();
const { isToggled, toggle } = useBooleanToggle();
const { setDeliveryInformationForItems } = useCheckout();
const courierMessage = ref<string>('');
let debounceTimer: ReturnType<typeof setTimeout> | null = null;
const textarea = ref<HTMLTextAreaElement | null>(null);
const doorStepDeliveryOptions = ref<(DeliveryOptionModel|undefined)[]>([]);
const deliveryTimeSlotModel = ref<DeliveryTimeSlotModel>({} as DeliveryTimeSlotModel);
const deliveryTimeSlotMessage = ref<LabelWithNamedArguments|undefined>();
const deliveryAddressMessage = ref<LabelWithNamedArguments|undefined>();
const selectedDeliveryTimeSlotId = ref<number|undefined>();
const showMore = ref(false);

const autoResize = () => {
    if (textarea.value) {
        textarea.value.style.height = '24px';
        textarea.value.style.height = `${textarea.value.scrollHeight}px`;
    }
};

onMounted(() => {
    if (textarea.value) {
        autoResize();
    }

    window.addEventListener('resize', autoResize);
});

onUnmounted(() => {
    window.removeEventListener('resize', autoResize);
});

watch(courierMessage, () => {
    if (debounceTimer) {
        clearTimeout(debounceTimer);
    }

    debounceTimer = setTimeout(() => {
        updateCourierMessage();
    }, 2000);
});

const setCourierText = () => {
    courierMessage.value = props.deliverable.comment || '';
};

setCourierText();

const onAddressChange = () => {
    setDeliverySlotOptions();
    setDeliveryInformationForItems(props.deliverable.id);
};

const maybeSetSelectedDeliveryTimeSlotId = () => {
    if (props.deliverable.deliveryType === DeliveryType.Shipping) {
        selectedDeliveryTimeSlotId.value = props.deliverable?.deliveryTimeId;
    }
};

maybeSetSelectedDeliveryTimeSlotId();

const onDoorStepDeliveryOptionChange = (option: DeliveryOptionWithSelectedValueModel) => {
    if (option.selected) {
        addDeliveryOption(props.deliverable.id, option.sku);
    } else {
        removeDeliveryOption(props.deliverable.id, option.sku);
    }
};

const deliveryAddress: ComputedRef<BasketAddress | undefined> = computed(() => {
    return props.deliverable.deliveryAddress?.address || invoiceAddress.value?.address;
});

const buyer = computed<BasketBuyer | undefined>(() => {
    return props.deliverable.deliveryAddress?.buyer || invoiceAddress.value?.buyer;
});

const countryCode = computed<string>(() => {
    return deliveryAddress.value?.countryCode || '';
});

const generalTermsAndConditionsTruncated = computed<string>(() => {
    return `${props.deliverable.generalTermsAndConditions?.substring(0, 150)}...`;
});

const generalTermsAndConditionsHTML = computed<string>(() => {
    const noticeLabel = labels.customerDeliveryShippingTermsHeading;
    return `<div class="font-bold">${noticeLabel}</div>${props.deliverable.generalTermsAndConditions}`;
});

const setDeliverySlotOptions = async(): Promise<void> => {
    const response = await getDeliveryTimesForCustomerDelivery(props.deliverable.id);
    deliveryTimeSlotMessage.value = undefined;
    deliveryAddressMessage.value = undefined;
    deliveryTimeSlotModel.value = {} as DeliveryTimeSlotModel;
    if (response.deliveryTimeSlotModel) {
        deliveryTimeSlotModel.value = response.deliveryTimeSlotModel;
        deliveryTimeSlotMessage.value = response.message;
        updateSelectedTimeSlotIfAvailableOrManualType();
    } else {
        deliveryAddressMessage.value = response.message;
    }
};

setDeliverySlotOptions();

const setDeliveryOption = async() => {
    const response = await getDeliveryOptions(countryCode.value);
    doorStepDeliveryOptions.value = response;
};

setDeliveryOption();

const doorStepDeliveryOptionsWithSelectedValue = computed<DeliveryOptionWithSelectedValueModel[]>(() => {
    return (doorStepDeliveryOptions.value as DeliveryOptionWithSelectedValueModel[]).map(option => {
        option.selected = !!props.deliverable.deliveryOptions?.find(sku => sku === option.sku) ?? false;
        return option;
    });
});

const updateSelectedTimeSlotIfAvailableOrManualType = (): void => {
    const firstAvailableSlot = deliveryTimeSlotModel.value.deliverySlots?.length ? deliveryTimeSlotModel.value.deliverySlots[0].deliveryTimeId : undefined;
    const containsTimeSlot = deliveryTimeSlotModel.value.deliverySlots?.find(slot => slot.deliveryTimeId === selectedDeliveryTimeSlotId.value) ?? false;
    const isManualTypeTimeSlot = deliveryTimeSlotModel.value.deliveryType === DeliveryType.Manual;

    if (!containsTimeSlot) {
        selectedDeliveryTimeSlotId.value = firstAvailableSlot;
    }

    if (containsTimeSlot || isManualTypeTimeSlot || firstAvailableSlot) {
        updateSelectedTimeSlot();
    }
};

const updateSelectedTimeSlot = async(): Promise<void> => {
    const request = {
        deliveryType: deliveryTimeSlotModel.value.deliveryType,
        requestedDeliveryType: deliveryTimeSlotModel.value.requestedDeliveryType,
        postalCode: deliveryTimeSlotModel.value.postalCode,
        inventoryLocationId: deliveryTimeSlotModel.value.inventoryLocationId,
        deliveryTime: deliveryTimeSlotModel.value.deliverySlots?.find(slot => slot.deliveryTimeId === selectedDeliveryTimeSlotId.value),
    };
    await setDeliveryTime(props.deliverable.id, request);
};

const updateCourierMessage = async(): Promise<void> => {
    const request = {
        comment: courierMessage.value,
    };

    await setCommentForHomeDelivery(props.deliverable.id, request);
};

const changeAddress = () => {
    toggle();
};

const shouldShowFreightPrice = computed<boolean>(() => {
    return props.deliverable.deliveryType === DeliveryType.Shipping && !!props.deliverable?.freight;
});


return (_ctx: any,_cache: any) => {
  const _component_InputSelect = _resolveComponent("InputSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, {
        name: "o-anim-fade-300",
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_unref(shouldShowFreightPrice))
            ? (_openBlock(), _createElementBlock("div", {
                key: __props.deliverable.freight?.price?.amount ?? 0
              }, [
                (__props.deliverable.freight?.errorGettingPrice)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(labels).customerDeliveryShippingPrice), 1),
                      _createTextVNode(_toDisplayString(_unref(labels).customerDeliveryShippingPriceAmountUnavailable), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(labels).customerDeliveryShippingPrice), 1),
                      _createTextVNode(_toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).customerDeliveryShippingPriceAmount, { amount: __props.deliverable.freight?.price?.amount })), 1)
                    ], 64))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    (__props.deliverable.generalTermsAndConditions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(labels).customerDeliveryShippingTermsHeading), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(generalTermsAndConditionsTruncated)), 1),
          _createElementVNode("button", {
            class: "c-magic-line c-magic-line--underline text-dusty-grey inline-block",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showMore.value = true), ["prevent"]))
          }, _toDisplayString(_unref(labels).customerDeliveryShippingTermsReadMoreButton), 1),
          _createVNode(BaseDialog, {
            "is-open": showMore.value,
            "onUpdate:is-open": _cache[1] || (_cache[1] = ($event: any) => ((showMore).value = $event)),
            class: "w-full mx-auto bg-white relative z-1 p-50 pb-20 max-w-750",
            description: _unref(generalTermsAndConditionsHTML)
          }, null, 8, ["is-open", "description"])
        ]))
      : (!deliveryTimeSlotMessage.value && !deliveryAddressMessage.value)
        ? (_openBlock(), _createBlock(CheckoutSkeletonLine, {
            key: 1,
            class: "mb-x2 mt-15 min-h-95"
          }))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(labels).customerDeliveryShippingAddressHeader), 1),
        (_unref(buyer)?.companyName)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(buyer)?.companyName), 1))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(buyer)?.firstName) + " " + _toDisplayString(_unref(buyer)?.lastName), 1),
        _createElementVNode("span", _hoisted_13, [
          _createTextVNode(_toDisplayString(_unref(deliveryAddress)?.street), 1),
          (_unref(deliveryAddress)?.street2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(", " + _toDisplayString(_unref(deliveryAddress)?.street2), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(deliveryAddress)?.postalCode) + " " + _toDisplayString(_unref(deliveryAddress)?.city), 1),
        _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(deliveryAddress)?.country), 1),
        (deliveryAddressMessage.value)
          ? (_openBlock(), _createBlock(BlockLabelWithNamedArguments, {
              key: 1,
              label: deliveryAddressMessage.value,
              class: "mt-x2"
            }, null, 8, ["label"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            class: "c-button c-button--outline",
            onClick: _withModifiers(changeAddress, ["prevent"])
          }, _toDisplayString(_unref(labels).customerDeliveryShippingChangeAddressButton), 9, _hoisted_17)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(labels).customerDeliveryShippingTimeslotTitle), 1),
        (!deliveryTimeSlotModel.value.deliverySlots)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(deliveryTimeSlotMessage.value || deliveryAddressMessage.value ? _unref(labels).customerDeliveryShippingTimeslotUnavailable : _unref(labels).customerDeliveryShippingTimeslotLoading), 1))
          : (_openBlock(), _createBlock(_component_InputSelect, {
              key: 1,
              modelValue: selectedDeliveryTimeSlotId.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedDeliveryTimeSlotId).value = $event)),
              class: "min-w-250",
              highlighted: true,
              name: `delivery-time-${__props.deliverable.id}`,
              "show-errors": false,
              onChange: updateSelectedTimeSlot
            }, {
              default: _withCtx(() => [
                (!selectedDeliveryTimeSlotId.value)
                  ? (_openBlock(), _createElementBlock("option", _hoisted_21, _toDisplayString(_unref(labels).customerDeliveryShippingSelectTimeslot), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveryTimeSlotModel.value.deliverySlots, (slot) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: slot.deliveryTimeId,
                    value: slot.deliveryTimeId
                  }, _toDisplayString(slot.formattedDeliveryDate), 9, _hoisted_22))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "name"])),
        (deliveryTimeSlotMessage.value)
          ? (_openBlock(), _createBlock(BlockLabelWithNamedArguments, {
              key: 2,
              label: deliveryTimeSlotMessage.value,
              class: "mt-x2"
            }, null, 8, ["label"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(labels).customerDeliveryCourierCommentHeading), 1),
      _createElementVNode("div", _hoisted_25, [
        _withDirectives(_createElementVNode("textarea", {
          ref_key: "textarea",
          ref: textarea,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((courierMessage).value = $event)),
          class: "c-input__field",
          type: "text",
          placeholder: _unref(labels).customerDeliveryCourierCommentPlaceholder,
          maxlength: "60",
          onInput: autoResize
        }, "\r\n                ", 40, _hoisted_26), [
          [_vModelText, courierMessage.value]
        ])
      ])
    ]),
    (doorStepDeliveryOptions.value?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(_TransitionGroup, {
            name: "o-anim-fade-200",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(labels).customerDeliveryShippingOptionsTitle), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(doorStepDeliveryOptionsWithSelectedValue), (option) => {
                return (_openBlock(), _createBlock(InputCheckbox, {
                  key: option?.sku,
                  modelValue: option.selected,
                  "onUpdate:modelValue": ($event: any) => ((option.selected) = $event),
                  name: `doorStepDeliveryOptions-${option.sku}`,
                  class: "mb-x2 pb-0 last:mb-0",
                  label: `${option.description} + ${option.price.amount}`,
                  "show-errors": false,
                  onInput: ($event: any) => (onDoorStepDeliveryOptionChange(option))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "label", "onInput"]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(CheckoutChangeAddress, {
      "deliverable-id": __props.deliverable.id,
      "delivery-address": __props.deliverable.deliveryAddress,
      "is-open": _unref(isToggled),
      onClose: _unref(toggle),
      onChange: onAddressChange
    }, null, 8, ["deliverable-id", "delivery-address", "is-open", "onClose"])
  ]))
}
}

})